export const SET_RESPONSE = 'app/OfficeSearcher/SET_RESPONSE';
export const LOAD_OFFICES = 'app/OfficeSearcher/LOAD_OFFICES';
export const FILTER_OFFICES = 'app/OfficeSearcher/FILTER_OFFICES';
export const SET_OFFICE_DISTANCE = 'app/OfficeSearcher/SET_OFFICE_DISTANCE';
export const SET_COMBO_OPTIONS = 'app/OfficeSearcher/SET_COMBO_OPTIONS';
export const SELECT_OFFICE = 'app/OfficeSearcher/SELECT_OFFICE';
export const TOGGLE_MAP = 'app/OfficeSearcher/TOGGLE_MAP';
export const SET_USER_COORDS = 'app/OfficeSearcher/SET_USER_COORDS';
